import React from 'react';
import * as S from './styles';
import { Button, Text } from 'v3/components';

function getButtonColor(value) {
  if (!value) return '#b6b6b6';
  return 'black';
}

export default function ChecklistExpiration({
  index,
  serviceLevel,
  updateValidity,
  isSingleChecklist = false,
}) {
  const dayColor = getButtonColor(serviceLevel.days);
  const tripColor = getButtonColor(serviceLevel.trips);

  return (
    <S.ChecklistExpiration key={index}>
      {serviceLevel.name && (
        <S.ChecklistExpirationLabel type="regular" weight={500}>
          {serviceLevel.name}
        </S.ChecklistExpirationLabel>
      )}

      <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
        <S.ChecklistExpirationGrid>
          <Button
            size="sm"
            onClick={() =>
              updateValidity(index, 'days', Math.max(0, serviceLevel.days - 1))
            }
          >
            –
          </Button>

          <S.ChecklistExpirationConditionInput
            type="text"
            inputMode="numeric"
            pattern="\d*"
            value={serviceLevel.days}
            onChange={e => {
              const digits = e.target.value.replace(/\D/g, '');
              updateValidity(index, 'days', Number(digits));
            }}
            style={{ color: dayColor }}
          />

          <Button
            size="sm"
            onClick={() =>
              updateValidity(index, 'days', serviceLevel.days + 1)
            }
          >
            +
          </Button>

          <Text type="regular" style={{ whiteSpace: 'nowrap' }}>
            {isSingleChecklist ? 'Dias avulsos' : 'Dias'}
          </Text>

          {isSingleChecklist ? (
            <>
              {/* <div style={{ width: '1rem' }} />

              <Button
                size="sm"
                onClick={() =>
                  updateValidity(
                    index,
                    'trips',
                    Math.max(0, serviceLevel.trips - 1)
                  )
                }
              >
                –
              </Button>

              <S.ChecklistExpirationConditionInput
                type="text"
                inputMode="numeric"
                pattern="\d*"
                value={serviceLevel.trips}
                onChange={e => {
                  const digits = e.target.value.replace(/\D/g, '');
                  updateValidity(index, 'trips', Number(digits));
                }}
                style={{ color: tripColor }}
              />

              <Button
                size="sm"
                onClick={() =>
                  updateValidity(index, 'trips', serviceLevel.trips + 1)
                }
              >
                +
              </Button>

              <Text type="regular" style={{ whiteSpace: 'nowrap' }}>
                Respostas para link
              </Text> */}
            </>
          ) : (
            <>
              <div style={{ width: '1rem' }} />

              <S.ChecklistExpirationCondition>
                <input
                  type="radio"
                  name={`operator-${index}`}
                  checked={serviceLevel.operator === 'AND'}
                  onChange={() => updateValidity(index, 'operator', 'AND')}
                />
                <Text type="regular">E</Text>
              </S.ChecklistExpirationCondition>

              <div style={{ width: '2rem' }} />

              <S.ChecklistExpirationCondition>
                <input
                  type="radio"
                  name={`operator-${index}`}
                  checked={serviceLevel.operator === 'OR'}
                  onChange={() => updateValidity(index, 'operator', 'OR')}
                />
                <Text type="regular">OU</Text>
              </S.ChecklistExpirationCondition>

              <div style={{ width: '1rem' }} />

              <Button
                size="sm"
                onClick={() =>
                  updateValidity(
                    index,
                    'trips',
                    Math.max(0, serviceLevel.trips - 1)
                  )
                }
              >
                –
              </Button>

              <S.ChecklistExpirationConditionInput
                type="text"
                inputMode="numeric"
                pattern="\d*"
                value={serviceLevel.trips}
                onChange={e => {
                  const digits = e.target.value.replace(/\D/g, '');
                  updateValidity(index, 'trips', Number(digits));
                }}
                style={{ color: tripColor }}
              />

              <Button
                size="sm"
                onClick={() =>
                  updateValidity(index, 'trips', serviceLevel.trips + 1)
                }
              >
                +
              </Button>

              <Text type="regular" style={{ whiteSpace: 'nowrap' }}>
                Viagens
              </Text>
            </>
          )}
        </S.ChecklistExpirationGrid>
      </div>
    </S.ChecklistExpiration>
  );
}
